import { createSelector } from 'reselect';

export const getAssignmentLink = (state) => state.assignmentLink;

export const getCurrentAssignmentId = (state) => state.assignmentLink.currentAssignmentId;

export const getCurrentAssignment = createSelector(
  [getAssignmentLink, getCurrentAssignmentId],
  (assignmentLink, currentAssignmentId) => assignmentLink[currentAssignmentId] || {},
);

export const getAssignmentLinkStatus = createSelector(
  [getCurrentAssignment],
  (currentAssignment) => currentAssignment.status,
);

export const getAssignmentLinkNavStatus = createSelector(
  [getCurrentAssignment],
  (currentAssignment) => currentAssignment.showNav,
);

export const getAssignmentLinkLevels = createSelector(
  [getCurrentAssignment],
  (currentAssignment) => currentAssignment.levels || [],
);

export const getAssignmentLinkLevelsMastered = createSelector(
  [getCurrentAssignment],
  (currentAssignment) => currentAssignment.levelsMastered || [],
);

export const getAssignmentLinkFailures = createSelector(
  [getCurrentAssignment],
  (currentAssignment) => currentAssignment.failures || {},
);
